import React from "react";

import { twJoin } from "tailwind-merge";

import { SimpleDropDown } from "src/base-components/SimpleDropDown";
import { Junctions } from "src/clients/flow-api";

export type ClauseBlockSize = "sm" | "md";

// The prefix column is 4 units wider than the junction so rows stay aligned.
export const CLAUSE_BLOCK_SIZES = {
  sm: { junctionWidth: "w-16", prefixWidth: "w-20" },
  md: { junctionWidth: "w-24", prefixWidth: "w-28" },
} as const;

const junctionOptions = Object.values(Junctions).map((val) => ({
  key: val,
  value: val,
}));

// The editable AND/OR selector shown next to the second row of a block or group.
export const JunctionDropdown: React.FC<{
  value: Junctions;
  onChange: (value: Junctions) => void;
  disabled: boolean;
  size: ClauseBlockSize;
  dataLoc?: string;
}> = ({ value, onChange, disabled, size, dataLoc }) => (
  <SimpleDropDown
    className={twJoin("h-8 shrink-0", CLAUSE_BLOCK_SIZES[size].junctionWidth)}
    dataLoc={dataLoc}
    disabled={disabled}
    elements={junctionOptions}
    itemsWidth={CLAUSE_BLOCK_SIZES[size].junctionWidth}
    placeholder=""
    placement="bottomLeft"
    selectedKey={value}
    onSelect={(key) => onChange(key as Junctions)}
  />
);
